/**
 * Progressive-enhancement AJAX for the PLP filter sidebar, sort dropdown,
 * applied-filter pills, and pagination (sections/collection.liquid).
 *
 * Intercepts filter/sort field changes and [data-ajax-link] clicks, fetches
 * the same collection URL with updated query params, and swaps the
 * [data-collection-page] markup in place. Falls back to a normal navigation
 * if fetch/DOMParser fails for any reason.
 */
(function () {
  var page = document.querySelector('[data-collection-page]');
  if (!page) return;

  // The page-hero search (rendered above the collection) filters the rendered
  // product grid in place on the collection page instead of navigating to the
  // search results page. It persists across AJAX swaps since it lives outside
  // [data-collection-page].
  var heroSearchForm = document.querySelector('.page-hero__search');
  var heroSearchInput = heroSearchForm ? heroSearchForm.querySelector('.page-hero__search-input') : null;
  var searchTimer;

  function getForm() {
    return page.querySelector('[data-collection-filter-form]');
  }

  function debounceSearch() {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(applyProductSearch, 200);
  }

  function applyProductSearch() {
    if (!heroSearchInput) return;

    var query = heroSearchInput.value.trim().toLowerCase();
    var grid = page.querySelector('.collection-products__grid');
    if (!grid) return;

    var visible = 0;
    grid.querySelectorAll('.product-card').forEach(function (card) {
      var titleEl = card.querySelector('.product-card__title');
      var title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      var match = !query || title.indexOf(query) !== -1;
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });

    var emptyEl = page.querySelector('[data-search-empty]');
    if (emptyEl) emptyEl.hidden = !(query && visible === 0);
  }

  function bind() {
    var form = getForm();
    if (!form) return;

    form.querySelectorAll('input, select').forEach(function (field) {
      field.addEventListener('change', function () {
        submitForm(form);
      });
    });

    page.querySelectorAll('[data-ajax-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        fetchAndReplace(link.href);
      });
    });
  }

  function submitForm(form) {
    // [data-collection-filter-form] is a <div>, not a <form> (its descendants
    // include the product cards' own add-to-cart forms, which can't be nested),
    // so gather fields manually instead of via FormData.
    //
    // Build the query from non-empty fields only. The price-range inputs are
    // always present in the DOM; submitting them empty sends
    // filter.v.price.gte=&filter.v.price.lte= which Shopify reads as a 0–0
    // range and returns no products.
    var params = new URLSearchParams();
    form.querySelectorAll('input, select').forEach(function (field) {
      if (!field.name) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (field.value !== '' && field.value != null) {
        params.append(field.name, field.value);
      }
    });

    var action = form.getAttribute('data-collection-action') || window.location.pathname;
    var query = params.toString();
    var url = query ? action + '?' + query : action;
    fetchAndReplace(url);
  }

  function fetchAndReplace(url) {
    page.classList.add('collection-page--loading');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPage = doc.querySelector('[data-collection-page]');

        if (newPage) {
          page.innerHTML = newPage.innerHTML;

          // The shared scroll-reveal observer only runs once on initial load,
          // so AJAX-injected `.reveal` elements (opacity: 0) would stay hidden.
          // Reveal them immediately — no entrance animation needed for results.
          page.querySelectorAll('[data-reveal]').forEach(function (el) {
            el.classList.add('is-visible');
          });

          bind();
          applyProductSearch();
        }

        history.pushState({}, '', url);
        page.classList.remove('collection-page--loading');
        page.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  bind();

  if (heroSearchForm && heroSearchInput) {
    heroSearchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyProductSearch();
    });
    heroSearchInput.addEventListener('input', debounceSearch);
  }

  window.addEventListener('popstate', function () {
    fetchAndReplace(window.location.href);
  });
})();
